<template>
  <div :style="{ width: isIe }">
    <div class="daohang">
      <div class="flexs">
        <div class="class-name">
          <span class="span1"></span>
          <span class="span2">{{ classInfo.course_name }}</span>
        </div>
        <el-button v-if="classInfo.cate === 1" @click="edit" style="margin-right: 14px" type="primary"
          icon="el-icon-delete" size="small">批量删除</el-button>

        <span>
          <span v-show="scflag" style="margin-right: 10px">
            <el-button v-if="classInfo.cate === 1" @click="upload" type="primary" icon="el-icon-upload2"
              size="small">上传</el-button>
          </span>
          <!-- <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >
            <el-button size="small" type="warning">全选</el-button>
            </el-checkbox
          > -->
          <el-button v-show="del_btn" size="small" type="warning" @click="delWriting"
            :disabled="del_list.length === 0 ? true : false">删除</el-button>
          <el-button v-show="del_btn" size="small" plain @click="cancel">取消</el-button>
        </span>
      </div>
      <div class="flexs">
        <el-select style="margin-right: 10px" v-model="classValue" placeholder="课程" size="small" @change="changeClass"
          v-if="classInfo.cate === 2">
          <el-option v-for="item in classInfo.courses" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <!-- <el-date-picker @change="changeData" size="small" v-model="value1" type="date" format="yyyy-MM-dd"
          value-format="yyyy-MM-dd" placeholder="请选择日期">
        </el-date-picker> -->
        <select-date :type="3" :course_id="classValue" @change-date="changeData"></select-date>
      </div>
    </div>

    <div class="writing flex">
      <div class="content" v-for="(item, index) in listData" :key="item.id">
        <div class="suspend"></div>
        <el-checkbox-group v-if="checkFlag" v-model="del_list" @change="handleCheckedCitiesChange">
          <el-checkbox :label="item.id">
            <div></div>
          </el-checkbox>
        </el-checkbox-group>
        <div class="kejian">
          <div class="class-left" @dblclick="inputFocus(index)">
            <!-- {{item.name | getCaption}} -->
            <img v-if="item.ext == 'pdfx' || item.ext == 'pdf'" src="../../../assets/app_img/icon_pdf.png" alt="" />
            <img v-if="item.ext == 'ppt' || item.ext == 'pptx'" src="../../../assets/app_img/icon_ppt.png" alt="" />
            <img v-if="item.ext == 'doc' || item.ext == 'docx'" src="../../../assets/app_img/icon_word.png" alt="" />
            <img v-if="item.ext == 'xls' || item.ext == 'xlsx'" src="../../../assets/app_img/icon_excel.png" alt="" />
            <img v-if="item.ext == 'txt'" src="../../../assets/app_img/icon_txt.png" alt="" />
            <img v-if="['png', 'jpg', 'jpeg', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(item.ext) !== -1"
              src="../../../assets/app_img/icon_picture.png" alt="">
            <!-- <span class="hide" :title="item.name">{{ item.name }}</span> -->
            <el-input v-if="classInfo.cate === 1 && isFocus && currentIndex === index" v-focus size="small"
              :maxlength="30" :title="item.name" :class="['hide', isFocus && currentIndex === index ? 'border' : '']"
              v-model="item.name" @blur="changeName(item)" @change="nameChange">
            </el-input>
            <span class="class-left-name" :title="item.name" v-else>{{ item.name }}</span>
          </div>
          <div class="class-right">
            <span>{{ item.update_time }}</span>
            <span>{{ item.size | capitalize }}</span>
            <!-- <span>一下载100次</span> -->
            <!-- <img
              @click="downloads(item)"
              src="../../../assets/app_img/btn_download_on.png"
              alt=""
            /> -->
            <i class="iconfont icon-xiazai i1" @click="downloads(item)"></i>
            <i v-if="classInfo.cate === 1" class="iconfont icon-arrow- i2" @click="share(item)"></i>
            <!-- <img @click="share(item)" src="../../../assets/app_img/btn_lock.png" alt="" /> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 空状态 -->
    <el-empty :image-size="200" v-if="empty"></el-empty>
    <!-- 分页 -->
    <el-pagination class="page" :hide-on-single-page="true" background layout="prev, pager, next"
      :total="pagination.total" :current-page="pagination.page" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-size="pagination.perPage">
    </el-pagination>
    <!-- 详情 -->
    <Detail ref="detail" :boardId="board_id"></Detail>
    <!-- 上传 -->
    <!-- <Upload ref="upload"></Upload> -->
    <!-- 分享 -->
    <Share ref="share" :shareid="shareid"></Share>
    <FileUpload v-if="isShowUpload" :isShowUpload="isShowUpload" :uploading="uploading" @closeDialog="closeDialog"
      @submitFile="submitUploads">
      <template #header>
        <div class="upload-info">
          <span class="seting-publish">设置发布时间 :</span>
          <el-date-picker v-if="isShowUpload" size="small" v-model="times" type="datetime" :picker-options="pickerOptions"
            placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" @focus="dateChnage">
          </el-date-picker>
        </div>
      </template>
    </FileUpload>
  </div>
</template> 

<script>
const cityOptions = ["上海", "北京", "广州", "深圳"]
import Detail from "./detail"
// import Upload from "./upload.vue"
import Share from "./share.vue"
import { mapState } from 'vuex'
import SelectDate from '../../../components/filterComponent/SelectDate.vue'
import FileUpload from "./components/Upload.vue"
import { saveAs } from 'file-saver'
export default {
  components: { Detail, Share, SelectDate, FileUpload },
  data () {
    return {
      empty: false,
      pageFlag: true,
      scflag: true,
      quanxian: Boolean,
      kechengName: "",
      classOptions: [],
      classValue: this.$store.state.classInfo.course_id,
      pagination: {},
      value1: '',
      flag: false,
      listData: [],
      dalogFlag: false,
      board_id: "",
      del_btn: false,
      cities: cityOptions,
      isIndeterminate: true,
      checkFlag: false,
      del_list: [],
      shareid: "", //分享的文件id
      isIe: "",
      isChange: false, // 名称是否发生了变化
      isFocus: false, // 修改名称的输入框聚焦
      currentIndex: null,
      isShowUpload: false, // 是否显示上传弹窗
      times: '',
      uploading: false, //是否显示上传的loading
      pickerOptions: {
        disabledDate: (time) => {
          let nowData = new Date()
          nowData = new Date(nowData.setDate(nowData.getDate() - 1))
          return time < nowData
        },
        //控制时分秒不可选
        selectableRange: '',
      },
    }
  },
  filters: {
    getCaption (obj) {
      var index = obj.lastIndexOf(".")
      obj = obj.substring(index + 1, obj.length)
      return obj
    },
  },
  computed: {
    ...mapState({
      cate: state => state.cate,
      classInfo: state => state.classInfo
    })
  },
  watch: {
    'classInfo.id' (val, oldVal) {
      this.value1 = ''
      this.classValue = this.classInfo.course_id
      this.writingData()
    },
    times (val, oldVal) {
      const newDate = val.substring(0, 11)
      const oldDate = oldVal.substring(0, 11)
      if (newDate > oldDate) {
        this.pickerOptions.selectableRange = '00:00:00 - 23:59:59'
      }
    }
  },
  mounted () {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      this.isIe = "1677px"
    } else {
      this.isIe = "100%"
    }
    if (window.localStorage.getItem("cate") == 1) {
      this.quanxian = true
    } else {
      this.quanxian = false
    }
    this.writingData()
    // 课程列表
    // this.changeClassName()
    // 获取课程名称
    // this.getClassName()
  },
  filters: {
    capitalize: function (size) {
      if (size < 1024) {
        size = size + "kb"
        // (Math.round((size * 100) / (1024 * 1024)) / 100).toString() + "KB";
      } else {
        size = (Math.round(size / 1024) / 1).toString() + "MB"
      }
      return size
    },
  },
  methods: {
    // 名称发生变化
    nameChange () {
      this.isChange = true
    },
    // 修改名称的输入框聚焦
    inputFocus (index) {
      this.isFocus = true
      this.currentIndex = index
    },
    async changeName (item) {
      console.log("文件名称:", item.name)
      this.isFocus = false

      // 如果名称未发生变化则不调用修改名称接口
      if (!this.isChange) {
        return false
      }

      if (item.name.length === 0) {
        this.writingData()
        return false
      }

      const res = await this.$axios.post("/base/file/update", {
        name: item.name,
        file_id: item.id,
      })
      if (res.status == 200 && res.data.errCode == 0) {
        this.$message.success(res.data.message)
        this.writingData()
        // 名称修改成功之后，isChange置为false，方便下一次使用
        this.isChange = false
      } else {
        this.$message.error(res.data.message)
      }
    },
    //kb转mb
    formatSize (size) {
      if (size > 1024 * 1024) {
        size =
          (Math.round((size * 100) / (1024 * 1024)) / 100).toString() + "MB"
      } else {
        size = (Math.round((size * 100) / 1024) / 100).toString() + "KB"
      }
      return size
    },
    // 分享
    async share (item) {
      this.shareid = item.id
      this.$refs.share.dialogVisible = true
      // const res = await this.$axios.post("/base/file/share", {
      //   class_ids: window.localStorage.getItem("class_id"),
      //   course_ids: window.localStorage.getItem("course_id"),
      //   file_id:item.id,
      // });
      // if (res.status == 200 && res.data.errCode == 0) {
      //   this.$message.success(res.data.message)
      // } else {
      //   this.$message.error(res.data.message);
      // }
    },
    getCaption (obj) {
      var index = obj.lastIndexOf(".")
      obj = obj.substring(index + 1, obj.length)
      return obj
    },
    // 下载
    downloadUrlFile (url, fileName) {
      return new Promise((resolve, reject) => {
        var blob = null
        var xhr = new XMLHttpRequest()
        xhr.open("GET", url)
        // xhr.setRequestHeader('Accept', 'image/png')
        xhr.responseType = "blob"
        // 加载时处理
        xhr.onload = () => {
          // 获取返回结果
          blob = xhr.response
          let file = new File([blob], fileName, { type: 'image/png' })
          // 返回结果
          resolve(file)
        }
        xhr.onerror = (e) => {
          reject(e)
        }
        // 发送
        xhr.send()
      })
    },
    async downloads (item) {
      const { file, file_url, name, ext } = item
      const files = await this.downloadUrlFile('api/' + file, name)
      const download_name = name.indexOf('.' + ext) !== -1 ? name : name + `.${ext}`
      saveAs(new Blob([files], { type: 'text/plain;charset=UTF-8' }), download_name)
      // window.open(item.file_url)
    },
    // 分页
    handleSizeChange (val) {
      this.pagination.total = val
      this.writingData()
    },
    handleCurrentChange (val) {
      this.pagination.page = val
      this.writingData()
    },
    // 删除
    delWriting () {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post("/base/file/batch/del", {
              file_ids: this.del_list,
            })
            .then((res) => {
              if (res.data.errCode == 0 && res.status == 200) {
                this.writingData()
                this.checkFlag = false
                this.del_btn = false
                this.scflag = true
                this.del_list = []
                this.$message({
                  type: "success",
                  message: res.data.message,
                })
              } else {
                this.scflag = true
                this.$message({
                  type: "error",
                  message: res.data.message,
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },
    // 单选
    handleCheckedCitiesChange (value) {
      this.del_list = value
      let checkedCount = value.length
      this.checkAll = checkedCount === this.cities.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length
    },
    // 历史板书
    changeData (val) {
      const date = val
      date !== null ? this.value1 = date : this.value1 = ''
      this.pagination.page = 1
      this.writingData()
      // const res = await this.$axios.post("/base/file/date", {
      //   class_id: window.localStorage.getItem("class_id"),
      //   course_id: window.localStorage.getItem("course_id"),
      //   date: val,
      // })
      // if (res.status == 200 && res.data.errCode == 0) {
      //   this.listData = res.data.data
      //   this.empty = false
      //   if (res.data.data.length == 0) {
      //     this.pageFlag = false
      //     this.empty = true
      //   }
      // } else {
      //   this.$message.error(res.data.message)
      // }
    },
    tobanshu () {
      this.flag = true
    },
    // 编辑
    edit () {
      this.del_btn = true
      // 控制删除radius
      this.checkFlag = true
      this.scflag = false
    },
    // 上传
    upload () {
      this.isShowUpload = true
      this.getNowTime()
    },
    // 关闭上传窗口，取消上传
    closeDialog () {
      this.isShowUpload = false
      this.times = ''
    },
    // 取消
    cancel () {
      this.del_btn = false
      this.checkFlag = false
      this.scflag = true
      this.del_list = []
    },
    // 列表
    async writingData () {
      const { id } = this.classInfo
      const res = await this.$axios.post("/base/file/list", {
        class_id: id,
        course_id: this.classValue,
        date: this.value1,
        page: this.pagination.page,
        perPage: 12,
      })
      if (res.status == 200 && res.data.errCode == 0) {
        if (res.data.data.length == 0) {
          this.empty = true
          this.pageFlag = false
        } else {
          this.empty = false
        }
        this.listData = res.data.data
        this.pagination = res.data.meta.pagination
      } else {
        this.$message.error(res.data.message)
      }
    },
    // 详情
    writingDetail (item) {
      this.board_id = item.id
      this.dalogFlag = true
      this.$refs.detail.imgs = item.video_url
      this.$refs.detail.dialogVisible = true
    },
    // 课程列表数据
    // async changeClassName () {
    //   const res = await this.$axios.post("/base/class/courses", {
    //     class_id: window.localStorage.getItem("class_id"),
    //   })
    //   if (res.status == 200 && res.data.errCode == 0) {
    //     this.classOptions = res.data.data
    //   } else {
    //     this.$message.error(res.data.message)
    //   }
    // },
    // 获取当前课程名称
    // async getClassName () {
    //   const res = await this.$axios.post("/base/class/choose", {
    //     class_id: window.localStorage.getItem("class_id"),
    //     course_id: window.localStorage.getItem("course_id"),
    //   })
    //   if (res.status == 200 && res.data.errCode == 0) {
    //     this.kechengName = res.data.data.course_name
    //   } else {
    //     this.$message.error(res.data.message)
    //   }
    // },
    // 选择课程
    changeClass (id) {
      // window.localStorage.setItem("course_id", id)
      this.classValue = id
      // 列表数据
      this.writingData()
      // 课程列表
      // this.changeClassName()
      // 获取课程名称
      // this.getClassName()
    },
    // 发布时间修改
    dateChnage () {
      const date = this.getNowTime()
    },
    // 获取当前时间
    getNowTime () {
      // var date = new Date();
      const dt = new Date()

      const y = dt.getFullYear()
      //padStart(2,0)   第一个参数是一共几个字符，第二个是补全字符    字符串补全功能  头部补全
      //padEnd     尾部补全
      const m = (dt.getMonth() + 1 + '').padStart(2, '0')
      const d = (dt.getDate() + '').padStart(2, '0')

      const hh = (dt.getHours() + '').padStart(2, '0')
      const mm = (dt.getMinutes() + '').padStart(2, '0')
      const ss = (dt.getSeconds() + '').padStart(2, '0')
      this.times = `${y}-${m}-${d} ${hh}:${mm}:${ss}`
      this.pickerOptions.selectableRange = `${hh}:${mm}:${ss} - 23:59:59`
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
    },
    // 上传课件
    async submitUploads (file) {
      const files = file
      try {
        let result = await new Promise((resolve, reject) => {
          this.uploading = true
          files.forEach(async (item, index) => {
            const formData = new FormData()
            formData.append('class_id', this.classInfo.id)
            formData.append('course_id', this.classInfo.course_id)
            formData.append('file', item.raw)
            formData.append('name', item.name)
            // console.log(item.raw)
            // 文件后缀名大写转小写
            // const nameStr = item.name
            // const strIndex = nameStr.lastIndexOf('.')
            // const name = nameStr.substring(0, strIndex)
            // const suffix = nameStr.substring(strIndex + 1, nameStr.length).toLowerCase()
            // const fileName = name + '.' + suffix
            // formData.append('name', fileName)

            // const name = item.name
            // if (index === 1) {
            //   formData.append('release_time', this.getNowTime())
            // } else {
            //   formData.append('release_time', '2023-02-01')
            // }
            const time = this.times ? this.times : this.getNowTime()
            formData.append('release_time', time)

            const { data: res } = await this.$axios.post('/base/file/upload', formData)
            if (res.errCode === 0) {
              this.$set(files[index], 'status', 'success')
              return resolve(res)
            } else {
              this.$set(files[index], 'status', 'error')
              return reject(res.message)
            }
          })
        })
        if (result.errCode === 0) {
          this.$message.success(result.message)
          this.writingData()
          this.times = ''
          this.isShowUpload = false
          this.uploading = false
        }
      } catch (error) {
        this.$message.error(error)
        this.uploading = false
      }



    }
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-checkbox__input {
  position: absolute;
  // top: -20px;
  // right: -760px;
}

/deep/ .el-checkbox-group {
  position: absolute;
  right: 6px;
  top: -10px;
}

/deep/ .el-checkbox__inner::after {
  height: 15px;
  left: 8px;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background: #e6a23c;
  border-color: #e6a23c;
}

/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #e6a23c;
}

/deep/ .el-checkbox__inner {
  border-radius: 50%;
  width: 24px;
  height: 24px;
}

/deep/ .el-checkbox__inner:hover {
  border-color: #e6a23c;
}

.flexs {
  display: flex;
  // justify-content: space-between;
}

.class-name {
  display: flex;
  margin-top: 4px;
  // display: inline-block;

  // display: flex;
  .span1 {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #da6013;
    border-radius: 50%;
    margin-right: 8px;
    margin-top: 8px;
    vertical-align: center;
  }

  .span2 {
    display: inline-block;
    // margin-right: 34px;
    vertical-align: center;
    font-weight: 600;
    width: 80px;
  }
}

.daohang {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d8e2eb;
  margin-bottom: 20px;
}

.flex {
  display: flex;
  flex-flow: wrap;
}

.writing {
  // margin-right: 15px;
  // margin-bottom: 15px;
  position: relative;
  margin-left: 20px;

  .content {
    // display: flex;
    // flex-flow: wrap;
    // -ms-flex-wrap: wrap;

    .suspend {
      position: absolute;
      width: 12px;
      height: 30px;
      border-radius: 30px;
      background: #2881cd;
      opacity: 0.6;
      top: 0;
      bottom: 0;
      left: -6px;
      margin: auto;
    }

    width: 750px;
    height: 88px;
    position: relative;
    margin:0 26px 20px 26px;
    // margin: 0 52px 20px 0;
    // padding: 12px;
    background: #fff;
    border-radius: 8px;
  }
}

.kejian:hover {
  box-shadow: 0px 10px 24px 0px #d8e2eb;
  // cursor: pointer;
}

.kejian {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;

  .class-left {
    display: flex;
    align-items: center;

    /deep/ .el-input__inner {
      font-size: 16px;
      background: none;
      border: none;
      // color: #fff;
      padding: 0;
      width: 280px !important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    span {}

    img {
      display: inline-block;
      width: 30px;
      height: 30px;
      // height: 16px;
      margin-right: 10px;
    }
  }

  .class-right {
    span:nth-child(2) {
      display: inline-block;
      width: 50px;
      margin-right: 40px;
    }

    span {
      margin-left: 20px;
    }

    display: flex;

    i {
      display: inline-block;
      margin-left: 20px;
      font-size: 20px;
      font-weight: 400;
      color: #e3e3e3;
    }

    i:hover {
      cursor: pointer;
      color: #2881cd;
    }
  }
}

.hide {
  width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.border {
  border: 1px solid #2881cd;
  padding: 0 10px;
  border-radius: 4px;
}

.class-left-name {
  display: inline-block;
  width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.page {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/Panel/kejian/index.vue